import { render, staticRenderFns } from "./CreateOrderDialog.vue?vue&type=template&id=4705a8fc&scoped=true&"
import script from "./CreateOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CreateOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderDialog.vue?vue&type=style&index=0&id=4705a8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4705a8fc",
  null
  
)

export default component.exports